import apiCall from '../utils/api-call/apiCall';
import { createHeaders } from './constants';

const apiList = async () => {
  const params = {
    populate: 'apiCategory',
  };
  return await apiCall('api-details', 'GET', params);
};
const apiCategortList = async () => {
  return await apiCall('get-company-apis', 'GET', null,  createHeaders());
};

const dashboardCharts = async (id, dashboardDates) => {
  const params = {
    apiId: id,
    startDate: dashboardDates?.startDate,
    endDate: dashboardDates?.endDate,
  };
  return await apiCall('api-consumption-dashboard', 'GET', params, createHeaders());
};

const apiUsageTrends = async (id, dashboardDates) => {
  const params = {
    apiId: id,
    startDate: dashboardDates?.startDate,
    endDate: dashboardDates?.endDate,
  };
  return await apiCall('v2/api-usage-trends', 'GET', params, createHeaders());
};

const apiUsageDistribution = async (id, dashboardDates) => {
  const params = {
    apiId: id,
    startDate: dashboardDates?.startDate,
    endDate: dashboardDates?.endDate,
  };
  return await apiCall('v2/api-usage-distribution', 'GET', params, createHeaders());
};

const usageData = async () => {
  const params = {
    apiId: 1,
    startDate: '2024-03-15',
    endDate: '2024-03-20',
  };
  return await apiCall('v2/api-uses-list', 'GET', params);
};

const viewLogs = async (params) => {
  const { filterDate, apiName, statusCode, token, page, pageSize, id } = params;
  const queryParams = {
    date: filterDate,
    apiName,
    statusCode,
    page,
    pageSize,
    apiId: id,
  };
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  return await apiCall('analytics/api-logs', 'GET', queryParams, headers);
};

const viewLogsV2 = async (params) => {
  const { filterDate, apiName, statusCode, token, page, pageSize, id } = params;
  const queryParams = {
    filterDate,
    apiName,
    statusCode,
    page,
    pageSize,
    apiId: id,
  };
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  return await apiCall('v2/api-logs', 'GET', queryParams, headers);
};

const dropDowndata = async (params) => {
  const { filterDate, token, id } = params;
  const queryParams = {
    filterDate,
    apiId: id,
  };
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  return await apiCall('api-logs/meta', 'GET', queryParams, headers);
};

const usageLogs = async (params) => {
  const { apiId, startDate, endDate } = params;
  const queryParams = {
    apiId,
    startDate,
    endDate,
    pageSize: 10000,
  };
  return await apiCall('v2/api-uses-list', 'GET', queryParams, createHeaders());
};

const downloadLogs = async (id, dashboardDates) => {
  const params = {
    apiId: id,
    startDate: dashboardDates.startDate,
    endDate: dashboardDates.endDate,
  };
  const responseType = 'blob';
  return await apiCall('export-api-log', 'GET', params, createHeaders(), responseType);
};

const getLogBySequenceId = async (requestId) => {
  const url = `api-logs/${requestId}`;
  return await apiCall(url, 'GET', null, createHeaders());
};

const averageResponseTime = async (startDate, endDate) => {
  const params = {
    startDate,
    endDate,
  };
  return await apiCall('average-response-time', 'GET', params, createHeaders());
};

const viewLogDashboardSummary = async (startDate, endDate) => {
  const params = {
    startDate,
    endDate,
  };
  return await apiCall('v2/view-logs-summary', 'GET', params, createHeaders());
};

//Dashboard Summary API
const dashboardSummary = async (token) => {
  return await apiCall('v2/dashboard-summary', 'GET', null, createHeaders(token));
};

//Dashboard Credit API
const dashboardCredits = async (token) => {
  return await apiCall('dashboard-credits', 'GET', null, createHeaders(token));
};

//Dashboard Recent Activity
const dashboardRecentActiviy = async (token) => {
  return await apiCall('recent-activities', 'GET', null, createHeaders(token));
};

//Dashboard Summary V2 API
const dashboardSummaryV2 = async (token) => {
  return await apiCall('v2/dashboard-summary', 'GET', null, createHeaders(token));
};

export {
  apiList, dashboardCharts, apiUsageTrends, apiUsageDistribution, usageData, viewLogs, viewLogsV2, dropDowndata, apiCategortList, downloadLogs, usageLogs, getLogBySequenceId, averageResponseTime, viewLogDashboardSummary, dashboardSummary, dashboardCredits, dashboardRecentActiviy, dashboardSummaryV2
};
